import z from 'zod'

import type { TicketPipelineConfig } from '../ticketPipelineConfig/ticketPipelineConfig.dto'

import { SubscriberIdSchema } from './subscriberId.dto'
export { SubscriberIdSchema } from './subscriberId.dto'

export const SegmentationStrategySchema = z.union([
  z.literal('Tags'),
  z.literal('Integration'),
  z.literal('TagsAndIntegration'),
  z.literal('None'),
])

export type SegmentationStrategy = z.infer<typeof SegmentationStrategySchema>

export const DataRetentionConfigSchema = z.object({
  enabled: z.boolean(),
})

export type DataRetentionConfig = z.infer<typeof DataRetentionConfigSchema>

export const DataRegionSchema = z.union([z.literal('US'), z.literal('AU')])

export type DataRegion = z.infer<typeof DataRegionSchema>

/** A subscriber is an entity that signs a contract with us. */
export const SubscriberSchema = z.object({
  id: SubscriberIdSchema,
  displayName: z.string(),
  authProviderOrganizationId: z.string().optional(),
  /**
   * The Slack channel ID where feedback should be sent.
   */
  slackFeedbackChannel: z.string().optional(),
  /**
   * The Slack channel ID where test conversation notifications should be sent.
   * Experimental but useful for proactive monitoring of a new subscriber.
   */
  slackTestNotificationChannel: z.string().optional(),
  segmentationStrategy: SegmentationStrategySchema,
  dataRegion: DataRegionSchema,
})

export type Subscriber = z.infer<typeof SubscriberSchema> & {
  ticketPipelineConfig: TicketPipelineConfig
  dataRetentionConfig: DataRetentionConfig
}

export type { SubscriberId } from './subscriberId.dto'
